import { render, staticRenderFns } from "./list-use.vue?vue&type=template&id=14880556&scoped=true"
import script from "./list-use.vue?vue&type=script&lang=ts"
export * from "./list-use.vue?vue&type=script&lang=ts"
import style0 from "./list-use.vue?vue&type=style&index=0&id=14880556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14880556",
  null
  
)

export default component.exports